import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListLastNameCell } from './user-list-last-name.cell';
import { UserListLastNameHeader } from './user-list-last-name.header';

export const UserListLastNameColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['lastName']
> = {
  enableSorting: true,
  header: UserListLastNameHeader,
  cell: UserListLastNameCell,
};
